import { isAxiosError } from 'axios'
import client from './client'
import type { User, AccountSettings } from '../types'

export async function getAccount(): Promise<User | null> {
  try {
    const { data } = await client.get<User>('/api/v1/account')
    return data
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 401) return null
    throw err
  }
}

export async function updateAccount(settings: Partial<AccountSettings>): Promise<User> {
  const { data } = await client.put<User>('/api/v1/account', settings)
  return data
}
